import React from 'react'
import IdentityIcon from 'mdi-react/FolderSearchOutlineIcon'
import ProtectIcon from 'mdi-react/ShieldHalfFullIcon'
import DetectIcon from 'mdi-react/AlertBoxIcon'
import RespondIcon from 'mdi-react/AmbulanceIcon'
import RecoverIcon from 'mdi-react/DatabaseSearchIcon'
import DevicesIcon from 'mdi-react/CellphoneLinkIcon'
import DataIcon from 'mdi-react/FileMultipleIcon'
import NetworkIcon from 'mdi-react/AccessPointNetworkIcon'
import UsersIcon from 'mdi-react/AccountMultipleIcon'

export const ControlSecurityIcon = props => {
  let comp = null

  if (props.type) {
    switch (props.type.toLowerCase()) {
      case 'identitiy':
        comp = <IdentityIcon color='#AEAEB0' />
        break
      case 'protect':
        comp = <ProtectIcon color='#AEAEB0' />
        break
      case 'detect':
        comp = <DetectIcon color='#AEAEB0' />
        break
      case 'respond':
        comp = <RespondIcon color='#AEAEB0' />
        break
      case 'recover':
        comp = <RecoverIcon color='#AEAEB0' />
        break
      default:
        comp = null
    }
  }

  return (comp)
}

export const ControlAssetIcon = props => {
  let comp = null
  if (props.type) {
    switch (props.type.toLowerCase()) {
      case 'devices':
        comp = <DevicesIcon color='#AEAEB0' />
        break
      case 'data':
        comp = <DataIcon color='#AEAEB0' />
        break
      case 'network':
        comp = <NetworkIcon color='#AEAEB0' />
        break
      case 'users':
        comp = <UsersIcon color='#AEAEB0' />
        break
      default:
        comp = null
    }
  }

  return (comp)
}



// WEBPACK FOOTER //
// ./src/utils/iconMapping.js